export enum RecaudacionesActionsKeysEnum {
  SALDOS = 'saldos',
  TRANSACCIONES = 'transacciones',
  RUBROS = 'rubros',
}
